$(function () {
    const latlng = {
        lat: -6.2241663,
        lng: 106.8078738
    };

    const map = new google.maps.Map(document.getElementById("map"), {
        center: latlng,
        zoom: 14,
        draggable: true,
        styles: [{
            elementType: "geometry",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }]
        }, {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#263c3f"
            }],
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#38414e"
            }],
        }, {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#212a37"
            }],
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#1f2835"
            }],
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
                color: "#2f3948"
            }],
        }, {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }],
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#17263c"
            }],
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#515c6d"
            }],
        }, {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#17263c"
            }],
        }]
    });
    
    const marker = new google.maps.Marker({
        map,
        position: latlng,
        title: "GROW IN ASIA CONSULTING",
    });

    const infoWindow = new google.maps.InfoWindow({
        content: `GROW IN ASIA CONSULTING`
    });
    infoWindow.open({
        map,
        anchor: marker,
        shouldFocus: false
    })
});
